<template>
  <div class="history-content">
    <v-switch
      color="green"
      v-model="team_switches.country_filter"
      label="Ansässig (Land)"
    ></v-switch>
    <div v-if="team_switches.country_filter">
      <label>Land</label>
      <v-autocomplete
        color="green"
        :items="this.$store.state.nationalities"
        item-text="item_text"
        item-value="id"
        v-model="user_data.team_country"
        solo
      ></v-autocomplete>
    </div>
    <v-switch
      color="green"
      v-model="team_switches.region_filter"
      label="Filtern nach Region/Verband"
    ></v-switch>
    <label v-if="team_switches.region_filter">Region/Verband</label>

    <v-select
      v-if="team_switches.region_filter"
      color="green"
      :items="$store.state.verband"
      v-model="user_data.team_verband"
      solo
    ></v-select>
    <label v-if="user_data.team_verband && team_switches.region_filter">Liga</label>
    <v-select
      solo
      v-if="user_data.team_verband && team_switches.region_filter"
      color="green"
      :items="$store.state.filter_leagues[user_data.team_verband]"
      item-text="league"
      item-value="league"
      v-model="user_data.team_league"
      multiple
    ></v-select>
    <v-switch
      color="green"
      v-model="team_switches.need_filter"
      label="Filtern nach Bedarf"
    ></v-switch>
    <div v-if="team_switches.need_filter">
      <label>Bedarf</label>
      <v-select
        color="green"
        :items="['Spieler', 'Trainer', 'Spieler & Trainer', 'Kein Bedarf']"
        v-model="user_data.team_need"
        solo
      ></v-select>
      <h3 v-if="user_data.team_need && user_data.team_need.includes('Spieler')">
        Spieler
      </h3>
      <label v-if="user_data.team_need && user_data.team_need.includes('Spieler')"
        >Position</label
      >
      <v-select
        v-if="user_data.team_need && user_data.team_need.includes('Spieler')"
        color="green"
        :items="$store.state.positions"
        v-model="user_data.team_need_positions"
        solo
        multiple
      ></v-select>
      <h3 v-if="user_data.team_need && user_data.team_need.includes('Trainer')">
        Trainer
      </h3>
      <label v-if="user_data.team_need && user_data.team_need.includes('Trainer')"
        >Trainertyp</label
      >
      <v-select
        v-if="user_data.team_need && user_data.team_need.includes('Trainer')"
        color="green"
        :items="$store.state.trainer_types"
        v-model="user_data.team_need_license"
        solo
        multiple
      ></v-select>
    </div>
    <v-btn
      flat
      @click="resetFilters('team_switches')"
      class="reset-filter-button button-small"
    >
      <v-icon class="mr-2">undo</v-icon> Alle Filter zurücksetzen
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'team-filter',

  props: {
    team_switches: {
      type: Object,
      default: () => {},
    },
    user_data: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    resetFilters(type) {
      this.$emit('reset-filters', type);
    },
  },
};
</script>
